<template>
  <v-footer
      dark
      padless
  >
    <v-card
        class="flex"
        flat
        tile
    >
      <cookie-law
          theme="blood-orange"
          transitionName="slideFromBottom"
          message="
We care about your experience online, that’s why we use cookies to make sure our website runs smoothly while personalising your visit for your ease of use and convenience."
      ></cookie-law>
      <v-card-title class="primary">
        <strong class="subheading">Get connected with us on our social networks!</strong>

        <v-spacer></v-spacer>

        <v-btn
            v-for="icon in icons"
            :key="icon"
            class="mx-4"
            dark
            icon
        >
          <v-icon size="24px">
            {{ icon }}
          </v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="py-2 white--text text-center">
        © {{ new Date().getFullYear() }} — <strong>SasaPay All Rights Reserved</strong>
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<script>
import CookieLaw from 'vue-cookie-law'
export default {
  name: "Footer",
  components: { CookieLaw },
  data: () => ({
    icons: [
      'mdi-facebook',
      'mdi-twitter',
      'mdi-linkedin',
      'mdi-instagram',
    ],
  }),
}
</script>

<style scoped>

</style>